import React, { ComponentProps } from 'react';
import { asView } from '../../../_lib/ViewFetcher';
import { Direction, TabPanel, Tabs } from '../../../components/molecules/Tabs';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { StatisticDaily, StatisticMonthly, StatisticYearly } from '../PageStatistics.types';
import { PageStatisticsTable } from '../partials/PageStatisticsTable';
import { PageStatisticsTableOnlyTotal } from '../partials/PageStatisticsTableOnlyTotal';

type PageStatistics = {
  daily: StatisticDaily[];
  monthly: StatisticMonthly[];
  yearly: StatisticYearly[];
};

function PageStatisticsDefault({ daily, monthly, yearly }: PageStatistics) {
  const { t } = useSonTranslation('PageStatistics');

  return (
    <Tabs initialActiveTab="page-statistics-tab-daily" direction={Direction.VERTICAL} label={t('tabs.label')}>
      <TabPanel buttonLabel={t('tabs.button.daily')} id="page-statistics-tab-daily">
        <PageStatisticsTable statistics={daily} type="daily" />
      </TabPanel>
      <TabPanel buttonLabel={t('tabs.button.monthly')} id="page-statistics-tab-monthly">
        <PageStatisticsTable statistics={monthly} type="monthly" />
      </TabPanel>
      <TabPanel buttonLabel={t('tabs.button.yearly')} id="page-statistics-tab-yearly">
        <PageStatisticsTableOnlyTotal statistics={yearly} type="yearly" />
      </TabPanel>
    </Tabs>
  );
}

export const PageStatisticsDefaultView = asView(PageStatisticsDefault);
export type PageStatisticsDefaultView = ComponentProps<typeof PageStatisticsDefaultView>;
